// In the editor the slider's own mousedown listener would swallow the gesture before the block's
// select / drag-to-reorder handlers see it, so an unfocused block can't be selected or reordered.
// Returns true when the slider must ignore pointer events: editor canvas only (not Preview, not the
// customer view) and only while the block is not focused.
export function getSliderPointerEventsDisabled({
  isSettings,
  isPreview,
  isFocused
}: {
  isSettings: boolean
  isPreview: boolean
  isFocused: boolean
}): boolean {
  return isSettings && !isPreview && !isFocused
}
